import i18next from 'i18next';

export function getUnit(unit, value) {
  if (unit === 'unit') {
    return i18next.t('STOCKS.STOCKS.FORM_PACKAGING_UNIT_LABEL', {
      count: value,
    });
  }
  return unit;
}

export default {
  getUnit,
};
